import React from "react";
import { Container, Row } from "react-bootstrap";
import cogoToast from "cogo-toast";
import { useTranslation } from 'react-i18next';
import CategoryLoading from "../PlaceHolder/CategoryLoading";
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { listFavourites, removeFavourite } from "../../network/favourite";
import { queryKeys } from "../../services/react-query/queryKeys";
import { Empty, Typography } from "antd";
import ProductCard from "../Comman/ProductCard";

const Favorite = () => {
  const { t, i18n } = useTranslation();
  const queryClient = useQueryClient();

  const { data: productData, isLoading } = useQuery({
    queryKey: [queryKeys.listFavorites, i18n],
    queryFn: listFavourites,
    enabled: !!i18n
  });

  const removeItem = async (id) => {
    try {
      await removeFavourite(id);
      cogoToast.success(t('message1'), { position: "top-right" });
      queryClient.invalidateQueries([queryKeys.listFavorites]);
    } catch (error) {
      cogoToast.error("Something went wrong!", { position: "top-right" });
    }
  };

  if (isLoading) {
    return (
      <Container>
        <Row> <CategoryLoading /></Row>
      </Container>
    );
  }

  if (!productData.data || productData.data.length === 0) {
    return (
      <div className="grid content-center h-[380px]">
        <Empty description={
          <Typography.Text>
            {t('no_data')}
          </Typography.Text>
        }
        />
      </div>
    );
  }

  return (
    <Container>
      <p className={"section-header"}>{t('headerfov')}</p>
      <p className={"section-p"}>{t('pfov')}</p>
      <Row>
        {productData.data.map((item, i) => (
          <ProductCard key={i} product={item.product} isFavorite onRemoveFavorite={() => removeItem(item.id)} />
        ))}
      </Row>
    </Container>
  );
};

export default Favorite;
